import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

export type ShowTimesDrawerState = {
  isShowTimesDrawerOpen: boolean;
};

const initState: ShowTimesDrawerState = {
  isShowTimesDrawerOpen: false,
};

export const useShowTimesDrawer = createStore({
  name: 'show-times-drawer',
  devtools: isDevtoolsEnabled,
  persist: false,
})(initState, set => {
  const handler = stateSetterHandler(set);
  return {
    setShowTimesDrawer: handler('isShowTimesDrawerOpen'),
  };
});
